// action types
const PURGE = "subtitle/PURGE";
const SET_SUBTITLE_LANG_LIST = "subtitle/SET_SUBTITLE_LANG_LIST";
const SET_SUBTITLE_LIST = "subtitle/SET_SUBTITLE_LIST";
const SET_SELECTED_SUBTITLE = "subtitle/SET_SELECTED_SUBTITLE";
const SET_CHANGED_SUBTITLE = "subtitle/SET_CHANGED_SUBTITLE";
const SET_CHANGED_TIMELINE_SUBTITLE = "subtitle/SET_CHANGED_TIMELINE_SUBTITLE";
const SET_SELECTED_LANGUAGE = "subtitle/SET_SELECTED_LANGUAGE";
const ADD_SUBTITLE = "subtitle/ADD_SUBTITLE";
const DELETE_SUBTITLE = "subtitle/DELETE_SUBTITLE";
const UPDATE_SUBTITLE = "subtitle/UPDATE_SUBTITLE";

// action creators (payload 통일)
export const purgeSubtitle = () => ({ type: PURGE });

export const setSubtitleLangList = (subtitleLangList) => ({
  type: SET_SUBTITLE_LANG_LIST,
  payload: { subtitleLangList }
});

export const setSubtitleList = (subtitleList) => ({
  type: SET_SUBTITLE_LIST,
  payload: { subtitleList }
});

export const setSelectedSubtitle = (selectedSubtitle) => ({
  type: SET_SELECTED_SUBTITLE,
  payload: { selectedSubtitle }
});

export const setChangedSubtitle = (changedSubtitle) => ({
  type: SET_CHANGED_SUBTITLE,
  payload: { changedSubtitle }
});

export const setChangedTimelineSubtitle = (changedTimelineSubtitle) => ({
  type: SET_CHANGED_TIMELINE_SUBTITLE,
  payload: { changedTimelineSubtitle }
});

export const setSelectedLanguage = (selectedLanguage) => ({
  type: SET_SELECTED_LANGUAGE,
  payload: { selectedLanguage }
});

export const addSubtitle = (idx, newSubtitle) => ({
  type: ADD_SUBTITLE,
  payload: { idx, newSubtitle }
});

export const deleteSubtitle = (idx) => ({
  type: DELETE_SUBTITLE,
  payload: { idx }
});

export const updateSubtitle = (idx, updatedFields) => ({
  type: UPDATE_SUBTITLE,
  payload: { idx, updatedFields }
});

// initial state
const initialState = {
  subtitleLangList: [],
  subtitleList: [],
  selectedSubtitle: '',
  changedSubtitle: {},
  changedTimelineSubtitle: {},
  selectedLanguage: {}
};

// reducer
export default function subtitle(state = initialState, action) {
  switch (action.type) {
    case PURGE:
      return { ...initialState };
    case SET_SUBTITLE_LANG_LIST:
      return { ...state, subtitleLangList: action.payload.subtitleLangList };
    case SET_SUBTITLE_LIST:
      return { ...state, subtitleList: action.payload.subtitleList };

    case SET_SELECTED_SUBTITLE:
      return { ...state, selectedSubtitle: action.payload.selectedSubtitle };

    case SET_CHANGED_SUBTITLE:
      return { ...state, changedSubtitle: action.payload.changedSubtitle };

    case SET_CHANGED_TIMELINE_SUBTITLE:
      return { ...state, changedTimelineSubtitle: action.payload.changedTimelineSubtitle };

    case SET_SELECTED_LANGUAGE:
      return { ...state, selectedLanguage: action.payload.selectedLanguage };

    case ADD_SUBTITLE: {
      const { idx, newSubtitle } = action.payload;
      const newList = [
        ...state.subtitleList.slice(0, idx + 1),
        newSubtitle,
        ...state.subtitleList.slice(idx + 1)
      ];
      return { ...state, subtitleList: newList };
    }

    case DELETE_SUBTITLE: {
      const { idx } = action.payload;
      const newList = [...state.subtitleList];
      newList.splice(idx, 1);

      if (newList.length === 0) {
        return {
          ...state,
          subtitleList: [{
            id: 0,
            start: 0,
            end: 1,
            content: ""
          }]
        };
      }

      return { ...state, subtitleList: newList };
    }

    case UPDATE_SUBTITLE: {
      const { idx, updatedFields } = action.payload;
      const newList = [...state.subtitleList];
      newList[idx] = {
        ...newList[idx],
        ...updatedFields
      };
      return { ...state, subtitleList: newList };
    }

    default:
      return state;
  }
}